/* eslint-disable react/no-unknown-property */
/* eslint-disable indent */
/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { Form, Col, Input, Tooltip, AutoComplete, Button, Select } from "antd";
import {
  checkNumbervalue,
  checkSpace,
  checkSpecialCharacter,
  preventTextPaste,
} from "../../../../utils";
import useClientAndDepartment from "../../CrediteBooking/useClientAndDepartment ";
import API from "../../../../api";
import urls from "../../../../api/urls";
import AutoCompleteAddress from "../../CrediteBooking/AutoCompleteAddress";

export const SenderFormFields = ({
  form,
  userInfo,
  resetForm,
  handleOnEnter,
  handleAPIKeyDown,
  handleKeyDown,
  getSenderPincode,
  handleKycTypeChange,
  selectedKycType,
  checkGST,
  senderPinCodeServiceableStatus,
  checkGSTStatus,
  disabledFeilds,
}) => {
  useEffect(() => {
    const handleResize = () => {
      setNumber(10);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const [number, setNumber] = useState(3);

  const kycOptions = [
    {
      value: "AADHAAR",
      label: "AADHAAR",
      maxLength: 12,
      regex: /^\d{12}$/, // Aadhar: 12-digit number
      message: "Aadhar must be a 12-digit number",
    },
    {
      value: "PAN",
      label: "PAN",
      maxLength: 10,
      regex: /^[A-Z]{5}\d{4}[A-Z]{1}$/, // PAN: 5 letters, 4 digits, 1 letter
      message:
        "PAN must be 5 letters, 4 digits, and 1 letter (e.g., ABCDE1234F)",
    },
    {
      value: "PASSPORT",
      label: "PASSPORT",
      maxLength: 8,
      regex: /^[A-Z][1-9]\d{6}$/, // Passport: 1 letter (not Z), 7 digits
      message:
        "Passport number must start with a letter (A-Z) and have 7 digits",
    },
    {
      value: "DRIVING_LICENCE",
      label: "DRIVING LICENCE",
      maxLength: 15,
      regex: /^[A-Z]{2}\d{13}$/, // Format: Two letters (state), two digits (RTO), space, 11 digits
      message: "Driving Licence must be in format: MH1200123456789",
    },
    {
      value: "VOTER_ID",
      label: "VOTER ID",
      maxLength: 10,
      regex: /^[A-Z]{3}\d{7}$/, // Format: 3 letters followed by 7 digits
      message:
        "Voter ID must be 3 letters followed by 7 digits (e.g., ABC1234567)",
    },
  ];

  const getKycValidationRule = () => {
    if (!selectedKycType) return [];
    const selectedOption = kycOptions?.find(
      (option) => option.value === selectedKycType
    );
    if (selectedOption) {
      return [
        {
          pattern: selectedOption.regex,
          message: selectedOption.message,
        },
      ];
    }
    return [];
  };

  const getMaxLength = (kycType) => {
    const selectedOption = kycOptions?.find(
      (option) => option.value === kycType
    );
    return selectedOption?.maxLength || 15; // Default maxLength
  };

  return (
    <>
      <Col lg={6} sm={6}>
        <Form.Item
          name="senderPincode"
          label="Sender Pincode"
          className="senderPincode"
          rules={[
            {
              required: true,
              message: "Enter sender pincode",
            },
            () => ({
              validator(rule, value = "") {
                if (value?.length > 0 && value?.length < 6) {
                  return Promise.reject("Pincode should be 6 digits");
                } else {
                  return Promise.resolve();
                }
              },
            }),
          ]}
          validateStatus={senderPinCodeServiceableStatus?.status}
          help={senderPinCodeServiceableStatus?.msg}
          onKeyPress={(event) => {
            if (event.key == "Enter") {
              event?.preventDefault();
              handleOnEnter(event);
            } else if (checkNumbervalue(event)) {
              event?.preventDefault();
            }
          }}
        >
          <Input
            onChange={(e) => {
              getSenderPincode(e);
            }}
            disabled={disabledFeilds}
            onInput={(e) => preventTextPaste(e, 6)}
            type="number"
            className="senderPincode"
            placeholder="Enter sender PIN code"
            maxLength={6}
            suffix={
              <span
                // className={
                //   pinCodeServiceableStatus?.serviceability ? "green" : "red"
                // }
                className={
                  senderPinCodeServiceableStatus?.serviceability
                    ? "green"
                    : "red"
                }
              >
                <Tooltip
                  title={
                    senderPinCodeServiceableStatus?.city?.length > number
                      ? senderPinCodeServiceableStatus?.city
                      : null
                  }
                >
                  {senderPinCodeServiceableStatus?.city?.length > number
                    ? senderPinCodeServiceableStatus?.city?.slice(0, number) +
                      "..."
                    : senderPinCodeServiceableStatus?.city}
                  {senderPinCodeServiceableStatus?.city ? "-" : null}
                  {senderPinCodeServiceableStatus?.stateCode}
                </Tooltip>
              </span>
            }
          />
        </Form.Item>
      </Col>
      <Col lg={6} sm={6}>
        <AutoCompleteAddress
          form={form}
          disabledFeilds={disabledFeilds}
          returnAddress={false}
          // alertData={alertData}
          resetForm={resetForm}
          // userInfo={userInfo}
          // setUseGoogleAddr={setUseGoogleAddr}
          // addressDetailsCallback={null}
          fieldName="senderAddress"
          label="Sender address"
          rules={[
            {
              required: true,
              message: "Enter sender address",
            },
          ]}
        />
        {/* <AutoCompleteAddress
          resetForm={resetForm}
          handleOnEnter={handleOnEnter}
          form={form}
          addressDetailsCallback={null}
          fieldName="senderAddress"
          label="Sender address"
          rules={[
            {
              required: true,
              message: "Enter sender address",
            },
          ]}
        /> */}
      </Col>

      <Col span={6}>
        <Form.Item
          label="Email address"
          name="senderEmail"
          rules={[
            {
              type: "email",
              message: "Give the correct email",
            },
          ]}
          onKeyPress={(e) => {
            if (e?.key == "Enter") {
              handleOnEnter(e);
            }
          }}
        >
          <Input
            maxLength={40}
            disabled={disabledFeilds}
            placeholder="Enter email address"
            onBlur={(e) =>
              form.setFieldValue(
                "returnEmail",
                e.target.value?.toLocaleLowerCase()
              )
            }
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item
          label="Sender Mobile number"
          name="senderMobileNumber"
          rules={[
            {
              required: true,
              message: "Enter sender mobile no.",
            },
            () => ({
              validator(rule, value = "") {
                if (value.length > 0 && value.length < 10) {
                  return Promise.reject("Enter 10 digits phone number");
                } else if (parseInt(value.substring(1, 0)) === 0) {
                  return Promise.reject("Mobile number should not be 0");
                } else {
                  return Promise.resolve();
                }
              },
            }),
          ]}
          onKeyPress={(e) => {
            if (e.key == "Enter") {
              handleOnEnter(e);
            } else if (/[^0-9]/.test(e?.key)) {
              e?.preventDefault();
            }
          }}
        >
          <Input
            placeholder="Enter phone number"
            maxLength={10}
            disabled={disabledFeilds}
            onInput={(e) => preventTextPaste(e, 10)}
            type="number"
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item
          label="GST number"
          name="senderGST"
          id="senderGST"
          validateStatus={checkGSTStatus?.status ? "success" : "error"}
          help={checkGSTStatus?.error}
          rules={[
            {
              required: false,
            },
            {
              pattern:
                /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
              message: "Enter valid GST",
            },
          ]}
          onKeyPress={(e) => {
            if (e?.key == "Enter") {
              handleOnEnter(e);
            } else if (checkSpecialCharacter(e) || checkSpace(e)) {
              e?.preventDefault();
            }
          }}
          // onChange={(e) => handleSenderGST(e)}
        >
          <Input
            placeholder="Enter GST"
            maxLength={15}
            disabled={disabledFeilds}
            onChange={checkGST}
            onInput={(e) => (e.target.value = e?.target?.value?.toUpperCase())}
          />
        </Form.Item>
      </Col>
      <Col sm={6}>
        <Form.Item
          label="KYC type"
          name="kycDocumentType"
          rules={[
            {
              required: true,
              message: "Select KYC",
            },
          ]}
        >
          <Select
            showAction={["focus", "click"]}
            disabled={disabledFeilds}
            showSearch
            filterOption={(input, option) =>
              (option?.label ?? "")
                .toLowerCase()
                ?.includes(input?.toLowerCase())
            }
            onKeyDown={(event) =>
              handleKeyDown(event, kycOptions, "kycDocumentType", "value")
            }
            onKeyPress={(e) => {
              if (e?.key == "Enter") {
                handleOnEnter(e, "kycDocumentNo");
              } else if (checkSpecialCharacter(e)) {
                e?.preventDefault();
              }
            }}
            onSelect={handleKycTypeChange}
            className="pincodeType-placecholder"
            placeholder="Select KYC"
            options={kycOptions}
          />
        </Form.Item>
      </Col>
      <Col span={6}>
        <Form.Item
          name="kycDocumentNo"
          id="kycDocumentNo"
          label="KYC number"
          dependencies={["kycDocumentType"]}
          validateTrigger={["onChange", "onFocus"]}
          rules={
            disabledFeilds
              ? [] // No validation rules if field is disabled
              : [
                  {
                    required: true,
                    message: "Enter number",
                  },
                  ...getKycValidationRule(),
                ]
          }
          // validateStatus={panStatus?.status}
          // help={panStatus?.msg}
          onKeyPress={(event) => {
            if (event?.key == "Enter") {
              handleOnEnter(event);
            } else if (checkSpecialCharacter(event) || checkSpace(event)) {
              event?.preventDefault();
            }
          }}
        >
          <Input
            // onChange={onPanChange}
            disabled={disabledFeilds}
            placeholder="Enter number"
            type="text"
            maxLength={getMaxLength(selectedKycType)}
            onInput={(e) => (e.target.value = e.target.value?.toUpperCase())}
          />
        </Form.Item>
      </Col>
    </>
  );
};
